import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { Box, Link, Input, Text, Flex } from "@chakra-ui/react";
import { ChevronRightIcon, QuestionOutlineIcon } from "@chakra-ui/icons";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { resetState } from "../../redux/actions/resetActions";

const Header = ({ template, dispatchResetState, formTitle }) => {
  const [redirect, setRedirect] = useState(false);
  const handleRedirect = (e) => {
    e.preventDefault();
    setRedirect(true);
  };
  useEffect(() => {
    if (redirect) {
      dispatchResetState();
    }
  }, [redirect]);
  return (
    <Flex h="50px" p="3" mb="8px" align="center" justify="space-between">
      <Box>
        <Flex align="center">
          {!Object.keys(template).length && redirect ? (
            <Redirect
              to={{
                pathname: "/forms",
                bredcrumb: true,
              }}
            />
          ) : null}
          <Link color="blue" onClick={handleRedirect}>
            Dashboard
          </Link>
          <ChevronRightIcon ml="2" />
          <Input
            width="200px"
            height="32px"
            ml="2"
            placeholder="Enter form name"
            value={formTitle}
          />
        </Flex>
      </Box>
      <Link color="blue" style={{ display: "flex" }}>
        <QuestionOutlineIcon mr="2" w="20px" h="20px" />
        <Text fontSize="14px" fontWeight="600" color="#2C5CC5">
          Help
        </Text>
      </Link>
    </Flex>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatchResetState: bindActionCreators(resetState, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(Header);
